import { AfterViewInit, Directive, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
    selector: '[overflowTooltip]',
})
export class OverflowTooltipDirective implements AfterViewInit {

    @Input('textElement') textElement;
    @Input('elementTooltip') elementTooltip: MatTooltip;

    constructor() {}

    ngAfterViewInit(): void {
        if (this.textElement.offsetWidth < this.textElement.scrollWidth) {
            this.elementTooltip.disabled = false;
        }
    }
}
